import { createTheme } from "@mui/material/styles";

// material UI
export const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#ffee71",
    },
  },
  typography: {
    htmlFontSize: 16,
    fontSize: 10,
  },
});
